const doc = [({"en":({"models":({"proposal_vote_result":({"no":"No", "yes":"Yes"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;